module.exports = __webpack_public_path__ + "img/icon-edit.7a14112e.svg";